/**
 * Collection naming utilities
 * Feature: 057-critique-quick-create, 825-folder-upload-support
 *
 * Shared utilities for generating default collection names.
 */

/**
 * Generate a default collection name for a user
 * Format: "<username> Photos on <short date>"
 *
 * @param username - The user's username
 * @param date - Optional date to use (defaults to today)
 * @returns Generated collection name
 *
 * @example
 * ```ts
 * generateCollectionName('alice');
 * // => "alice Photos on Dec 27"
 *
 * generateCollectionName('bob', new Date('2024-01-15'));
 * // => "bob Photos on Jan 15"
 * ```
 */
export function generateCollectionName(username: string, date: Date = new Date()): string {
  const shortDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${username} Photos on ${shortDate}`;
}

/**
 * Generate a default critique session title from a collection name
 * Format: "<collection name> Crit"
 *
 * @param collectionName - The collection name
 * @returns Generated session title
 *
 * @example
 * ```ts
 * generateCritiqueSessionTitle('alice Photos on Dec 27');
 * // => "alice Photos on Dec 27 Crit"
 * ```
 */
export function generateCritiqueSessionTitle(collectionName: string): string {
  return `${collectionName} Crit`;
}
